import { GoogleCalendar } from '../translations-types';

const translations: GoogleCalendar = {
  title: 'Google Calendar',
  description: "Connect your Google Calendar to see today's appointments and match them with your customers.",
  connectCalendar: 'Connect Google Calendar',
  disconnectCalendar: 'Disconnect',
  connected: 'Connected',
  notConnected: 'Not connected',
  connectedAs: 'Connected as',
  connectedAt: 'Connected since',
  connecting: 'Connecting...',
  disconnecting: 'Disconnecting...',
  connectSuccess: 'Google Calendar connected successfully.',
  disconnectSuccess: 'Google Calendar disconnected.',
  connectError: 'Failed to connect Google Calendar. Please try again.',
  reconnecting: 'Google Calendar connection expired — reconnecting…',
  scopeMissingTitle: 'Calendar permission missing',
  scopeMissingDescription:
    'The connection has no access to your calendars. Click "Connect Google Calendar" and make sure to tick the calendar permission on the Google screen.',
  todayAppointments: "Today's appointments",
  noAppointments: 'No appointments today.',
  time: 'Time',
  client: 'Client',
  matchedCustomer: 'Matched customer',
  notMatched: 'Not matched',
  calendarNotConnected: 'Calendar not connected',
  connectToSeeAppointments: "Connect your Google Calendar to see today's appointments.",
  selectCalendar: 'Select calendar',
  selectCalendarDescription: 'Choose which calendar to use for appointments.',
  selectedCalendar: 'Selected calendar',
  changeCalendar: 'Change',
  defaultCalendar: '(Default)',
  save: 'Save',
  loadingCalendars: 'Loading calendars...',
  appointments: 'Appointments',
  today: 'Today',
  tomorrow: 'Tomorrow',
  thisWeek: 'This week',
  panelTitle: 'Google Calendar (Salonized)',
  salonizedNote:
    'This Google calendar is fed by Salonized. Employee, treatment and a Salonized link are taken from the appointments.',
  sync: 'Synchronise now',
  syncPastYear: 'Synchronise past year',
  syncDone: 'Synchronisation complete',
  added: 'Added',
  updated: 'Updated',
  removed: 'Removed',
  matchedCustomers: 'Matched customers',
  unmatchedCustomers: 'Unmatched customers',
  ambiguous: 'Multiple matches',
  openInSalonized: 'Open in Salonized',
  calendarRequired: 'Choose a calendar',
  calendarRequiredNote: 'The connection is only complete once you choose a calendar below; otherwise nothing is synchronised.',
  connectedChooseCalendar: 'Connected to Google — now choose a calendar to complete the connection.',
  calendarModeSalon: 'One calendar for the whole salon',
  calendarModeEmployee: 'Per employee',
  employeeCalendarsTitle: 'Calendar per treating employee',
  employeeColumn: 'Employee',
  calendarColumn: 'Calendar',
  noCalendarAssigned: 'No calendar',
  employeeCalendarsHint:
    'Choose a calendar per treating employee. Only calendars shared with the connected Google account appear in the list.',
  assignAtLeastOne: 'Assign at least one calendar to an employee.',
  noTreatingEmployees: 'No treating employees for this location.',
  goBookyPanelTitle: 'Google Calendar (GoBooky)',
  goBookyNote:
    'This Google calendar is fed by GoBooky. Assign a calendar per treating employee; the customer comes from the "Klant:" field (matched by name or email) and the treatment from the appointment title.',
};

export default translations;
